import { gql } from '@apollo/client';

export const UPSERT_HIERARCHY_LEVEL = gql`
  mutation UpsertHierarchyLevel($input: UpsertHierarchyLevelInput!) {
    hierarchyLevel: upsertHierarchyLevel(input: $input) {
      id
    }
  }
`;
